import {
  Appointment02Icon,
  ChartUpIcon,
  DashboardSquareSettingIcon,
  Door02Icon,
  File02Icon,
  Folder01Icon,
  Notification01Icon,
  PieChart01Icon,
  PlazaIcon,
  UserCircleIcon,
  IdentityCardIcon,
  FlowIcon,
  CheckmarkSquare02Icon
} from "@hugeicons-pro/core-stroke-rounded";

export enum Links {
  CREDIT_IMPACT = "Credit impact",
  RENTERS = "Renters",
  RENT_REPORTING = "Rent reporting",
  APPLICATIONS = "Applications",
  SCREENING_SETTINGS = "Screening settings",
  ANALYTICS = "Analytics",
  PROPERTIES = "Properties",
  UNITS = "Units",
  PROPERTY_GROUPS = "Property groups",
  NOTIFICATIONS = "Notifications",
  TASKS = "Tasks",
  CONTACTS = "Contacts",
  WORKFLOWS = "Workflows"
}

export const boomReportLinks = [
  {
    name: Links.RENTERS,
    to: "/renters",
    Icon: UserCircleIcon,
    permission: "canViewRentersList"
  },
  {
    name: Links.RENT_REPORTING,
    to: "/rent-reporting",
    Icon: Appointment02Icon,
    permission: "canViewRentReporting"
  },
  {
    name: Links.CREDIT_IMPACT,
    to: "/credit-impact",
    Icon: ChartUpIcon,
    permission: "canViewCreditReporting",
    strokeWidth: 1.5
  }
];

export const globalLinks = [
  { name: Links.NOTIFICATIONS, to: "/notifications", Icon: Notification01Icon },
  { name: Links.TASKS, to: "/tasks", Icon: CheckmarkSquare02Icon, beta: true },
  {
    name: Links.CONTACTS,
    to: "/contacts",
    Icon: IdentityCardIcon,
    beta: true
  },
  { name: Links.UNITS, to: "/units", Icon: Door02Icon },
  { name: Links.PROPERTIES, to: "/properties", Icon: PlazaIcon },
  {
    name: Links.PROPERTY_GROUPS,
    to: "/property-groups",
    Icon: Folder01Icon
  },
  {
    name: Links.WORKFLOWS,
    to: "/workflows",
    Icon: FlowIcon
  }
];

export const boomScreenLinks = [
  { name: Links.APPLICATIONS, to: "/applications", Icon: File02Icon },
  {
    name: Links.SCREENING_SETTINGS,
    to: "/verification-templates",
    Icon: DashboardSquareSettingIcon
  },
  {
    name: Links.ANALYTICS,
    to: "/analytics",
    Icon: PieChart01Icon
  }
];
